/** https://wiki.yandex-team.ru/staff/api/photos */
export var sizes = [16, 18, 24, 25, 28, 30, 32, 36, 40, 42, 45, 48, 50, 55, 60, 64, 70, 72, 80, 85, 90, 100, 128, 140, 150, 192, 200, 220, 256, 300, 420, 460];
// #sourceMappingURL=constants.js.map